// UI login (contoh modul F0). Tak ada logika bisnis di sini — panggil auth.service.
import { login, type Session } from './auth.service';
import { isConfigured } from '@core/config';
import { pendingFactorId, verifyLoginCode } from './mfa.service';
import { logout } from './auth.service';
import { LOGO_IFICS } from '@ui/logo';

const LAST_EMAIL = 'ifics-last-email';

export function renderLogin(root: HTMLElement, onLogin: (s: Session) => void): void {
  // Username tetap saat login lagi (mis. setelah auto-logout idle) — hanya perlu isi password.
  let lastEmail = '', idleOut = false;
  try { lastEmail = localStorage.getItem(LAST_EMAIL) ?? ''; idleOut = localStorage.getItem('ifics-idle') === '1'; localStorage.removeItem('ifics-idle'); } catch { /* mode privat */ }
  root.innerHTML = `
    <div class="login-card" style="max-width:360px;margin:12vh auto;font-family:system-ui;padding:0 16px">
      <img src="${LOGO_IFICS}" alt="iFiCs" style="height:52px;width:auto;display:block;margin-bottom:10px">
      ${isConfigured() ? '' : `<div style="background:#fdf1dd;color:#b9770f;padding:8px;border-radius:8px;font-size:13px">
        ⚠️ Supabase belum dikonfigurasi. Isi <b>.env.local</b> (lihat README) lalu jalankan ulang.</div>`}
      ${idleOut ? `<div style="background:#fdf1dd;color:#b9770f;padding:8px;border-radius:8px;font-size:13px;margin-bottom:6px">🔒 Sesi berakhir karena tidak aktif. Masukkan password untuk lanjut.</div>` : ''}
      <label style="display:block;margin:12px 0 4px">Username / Email</label>
      <input id="lg_email" type="text" autocapitalize="none" autocomplete="username" placeholder="mis. teknisi" value="${lastEmail.replace(/"/g, '&quot;')}" style="width:100%;padding:10px;border:1px solid #dbe4ec;border-radius:8px" />
      <label style="display:block;margin:12px 0 4px">Password</label>
      <div style="position:relative">
        <input id="lg_pass" type="password" style="width:100%;padding:10px 44px 10px 10px;border:1px solid #dbe4ec;border-radius:8px" />
        <button type="button" id="lg_eye" aria-label="Tampilkan password" aria-pressed="false" title="Tampilkan password"
          style="position:absolute;right:6px;top:50%;transform:translateY(-50%);border:0;background:none;cursor:pointer;font-size:16px;padding:4px 6px;line-height:1">👁️</button>
      </div>
      <div style="text-align:right;margin-top:6px"><button type="button" id="lg_lupa" style="border:0;background:none;color:#1FA9E0;font-size:12.5px;cursor:pointer;padding:2px 0">Lupa password?</button></div>
      <div id="lg_err" style="color:#c0392b;font-size:13px;margin-top:8px"></div>
      <button id="lg_btn" style="width:100%;margin-top:14px;padding:12px;background:#0A2A4A;color:#fff;border:0;border-radius:8px;font-weight:600">Masuk</button>
    </div>`;

  const $ = (id: string) => root.querySelector<HTMLInputElement>('#' + id)!;
  // Kalau email sudah terisi (login ulang), langsung ke password.
  if (lastEmail) $('lg_pass').focus();
  const submit = async (): Promise<void> => {
    const err = root.querySelector('#lg_err')!;
    err.textContent = '';
    const email = $('lg_email').value.trim();
    try {
      const s = await login(email, $('lg_pass').value);
      // 2FA: password saja belum cukup bila akun ini mendaftarkan authenticator. Kode diminta
      // SEBELUM aplikasi dibuka; kalau dibatalkan, sesinya ditutup lagi supaya tak tertinggal setengah.
      const factorId = await pendingFactorId();
      if (factorId) {
        const ok = await mintaKode2FA(root, factorId);
        if (!ok) { await logout(); renderLogin(root, onLogin); return; }   // rakit ulang layar login (listener lama ikut hilang saat kartunya ditimpa)
      }
      try { localStorage.setItem(LAST_EMAIL, email); } catch { /* mode privat */ }
      onLogin(s);
    } catch (e) {
      err.textContent = (e as Error).message;
    }
  };
  // Toggle lihat password — salah ketik password di HP itu lumrah; tanpa ini orang menebak-nebak
  // apakah gagal login karena password salah atau salah ketik. Kembali tersembunyi setelah dipakai.
  const mata = root.querySelector<HTMLButtonElement>('#lg_eye');
  mata?.addEventListener('click', () => {
    const f = $('lg_pass');
    const tampil = f.type === 'password';
    f.type = tampil ? 'text' : 'password';
    mata.textContent = tampil ? '🙈' : '👁️';
    mata.setAttribute('aria-pressed', String(tampil));
    mata.setAttribute('aria-label', tampil ? 'Sembunyikan password' : 'Tampilkan password');
    f.focus();
  });
  // Lupa password → tautan pemulihan dikirim ke email akun. Hanya berguna bagi akun yang email
  // loginnya email ASLI (Owner); karyawan memakai username@ifics.local, jadi diarahkan ke Owner.
  root.querySelector('#lg_lupa')?.addEventListener('click', () => void (async () => {
    const err = root.querySelector('#lg_err')!;
    const email = $('lg_email').value.trim();
    if (!email) { err.textContent = 'Isi dulu username/email Anda di atas, lalu klik "Lupa password?".'; return; }
    if (!email.includes('@')) { err.textContent = 'Akun karyawan tak memakai email pribadi — minta Owner mereset password Anda.'; return; }
    if (/@ifics\.local$/i.test(email)) { err.textContent = 'Akun ini tak memakai email pribadi — minta Owner mereset password Anda.'; return; }
    err.textContent = 'Mengirim…';
    const { supabase } = await import('@core/supabase');
    const { error } = await supabase().auth.resetPasswordForEmail(email, { redirectTo: window.location.origin + window.location.pathname });
    // Pesannya sengaja sama untuk email terdaftar maupun tidak — supaya orang luar tak bisa
    // menebak-nebak alamat mana yang punya akun di sini.
    err.textContent = error && !/rate|limit/i.test(error.message)
      ? error.message
      : '📧 Bila email itu terdaftar, tautan reset sudah dikirim. Cek kotak masuk & folder spam.';
  })());
  $('lg_btn').addEventListener('click', () => void submit());
  $('lg_pass').addEventListener('keydown', (e) => { if ((e as KeyboardEvent).key === 'Enter') void submit(); });
}

/** Layar kode 2FA saat login — menggantikan isi kartu login sampai kodenya benar / dibatalkan. */
function mintaKode2FA(root: HTMLElement, factorId: string): Promise<boolean> {
  return new Promise((resolve) => {
    const kartu = root.querySelector<HTMLElement>('.login-card') ?? root;
    const simpan = kartu.innerHTML;
    kartu.innerHTML = `
      <div style="font-size:15px;font-weight:700;margin-bottom:4px">🔐 Verifikasi Dua Langkah</div>
      <div style="font-size:13px;color:#6b7a8a;margin-bottom:12px">Buka aplikasi authenticator Anda, lalu masukkan 6 angka yang tampil.</div>
      <input id="mfa_code" inputmode="numeric" autocomplete="one-time-code" maxlength="6" placeholder="123456"
        style="width:100%;padding:12px;border:1px solid #dbe4ec;border-radius:8px;font-size:22px;letter-spacing:.35em;text-align:center;font-family:ui-monospace,monospace">
      <div id="mfa_err" style="color:#c0392b;font-size:13px;margin-top:8px"></div>
      <button id="mfa_ok" style="width:100%;margin-top:12px;padding:12px;background:#0A2A4A;color:#fff;border:0;border-radius:8px;font-weight:600">Verifikasi</button>
      <button id="mfa_batal" style="width:100%;margin-top:8px;padding:10px;background:none;color:#6b7a8a;border:0">Batal</button>`;
    const inp = kartu.querySelector<HTMLInputElement>('#mfa_code')!;
    const err = kartu.querySelector<HTMLElement>('#mfa_err')!;
    const ok = kartu.querySelector<HTMLButtonElement>('#mfa_ok')!;
    inp.focus();
    const selesai = (hasil: boolean): void => { kartu.innerHTML = simpan; resolve(hasil); };
    const coba = async (): Promise<void> => {
      err.textContent = ''; ok.disabled = true; ok.textContent = 'Memeriksa…';
      try { await verifyLoginCode(factorId, inp.value); selesai(true); }
      catch (e) { err.textContent = (e as Error).message; ok.disabled = false; ok.textContent = 'Verifikasi'; inp.select(); }
    };
    ok.addEventListener('click', () => void coba());
    inp.addEventListener('keydown', (e) => { if ((e as KeyboardEvent).key === 'Enter') void coba(); });
    kartu.querySelector('#mfa_batal')?.addEventListener('click', () => selesai(false));
  });
}
